import { type ObjectWithName } from '@/lib/types';

const sortByName = (a: ObjectWithName, b: ObjectWithName): number => {
  return a.name.localeCompare(b.name);
};

export default sortByName;
